import { ChangeHistoryRecord } from '../../store/ChangeHistory';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

export const listChangeHistory = async (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'changedAt', direction: 'desc' }]
  };

  return await apiService.callExternalApi<PaginatedResponse<ChangeHistoryRecord>>({
    url: buildAdvancedQueryURL(mergedFilters, 'change-history'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
